import React, { useEffect, useState } from 'react'
import { useUserContext } from 'context/user'
import { CheckUserAccess } from 'components/accessability'
import { ErrorComponent } from '@pankod/refine-antd'
import ProjectListComponent from 'components/project_setup'

export const ProjectLists = () => {
  const [errorCode, setErrorCode] = useState<number>(200)
  const { userRole } = useUserContext()
  //checking user accessability
  useEffect(() => {
    const code: any = CheckUserAccess('project_setup', 'list', '', '', userRole)
    setErrorCode(code)
  }, [userRole])

  return errorCode === 200 ? (
    <>
      <ProjectListComponent />
    </>
  ) : (
    <ErrorComponent />
  )
}
